import { useTranslations } from "next-intl";

import FilterGroup from "@/components/FilterBar/FilterMenu/FilterGroup";
import Modal from "@/components/Modal";
import type { IFilterObject } from "@/lib/centra/useProductFilter/filterFormatter";
import stopPropagation from "@/lib/utils/stopPropagation";
import type { FormattedFilters } from "@/types/filters";

import styles from "./filterMenu.module.scss";

interface UIProps {
  filters: FormattedFilters | undefined;
  toggleMenu: (e: any) => void;
  show: boolean;
  productCount: number;
  close: () => void;
  clearFilters: () => void;
}

const UI = ({
  filters,
  toggleMenu,
  show,
  productCount,
  close,
  clearFilters,
}: UIProps) => {
  let activeFilters: IFilterObject[] = [];
  filters?.map((filterType) => {
    filterType.filters.map((filter) => {
      if (filter.active) activeFilters.push(filter);
    });
  });

  const t = useTranslations();

  return (
    <div className={styles.container}>
      <div className={styles.button}>
        <p onClick={toggleMenu}>
          Filter
          {activeFilters.length > 0 && <span>({activeFilters.length})</span>}
        </p>
      </div>
      {activeFilters.length > 0 && (
        <div className={styles.filterTags}>
          {activeFilters.map((filter) => (
            <span
              key={`filter-${filter.value}`}
              className={styles.tag}
              onClick={filter.toggle}
            >
              {filter.label}
              <span className={styles.remove}>&times;</span>
            </span>
          ))}
          <button onClick={() => clearFilters()} className={styles.clear}>
            {t("clearFilter")}
          </button>
        </div>
      )}
      <Modal isOpen={show} close={close} animation="left">
        <div className={styles.grid}>
          <div className={styles.content} onClick={stopPropagation}>
            <div className={styles.header}>
              <div className={styles.filter}>
                <h2>
                  Filter
                  {activeFilters.length > 0 && (
                    <span>({activeFilters.length})</span>
                  )}
                </h2>
                {activeFilters.length > 0 && (
                  <button
                    onClick={() => clearFilters()}
                    className={styles.filterClearButton}
                  >
                    {t("clear")}
                  </button>
                )}
              </div>
              <span className={styles.close} onClick={(e) => toggleMenu(e)}>
                {t("close")}
              </span>
            </div>
            <div className={styles.filters}>
              {filters?.map((filterGroup) => {
                return (
                  filterGroup.name && (
                    <FilterGroup
                      filterGroup={filterGroup}
                      key={filterGroup.name}
                      open={false} //key === 0
                    />
                  )
                );
              })}
            </div>
            <div className={styles.footer}>
              <p>
                {productCount} {t("products")}
              </p>
              <button className={styles.apply} onClick={(e) => toggleMenu(e)}>
                {activeFilters.length > 0 ? t("applyFilter") : t("closeFilter")}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default UI;
